import React from "react";
import "../../App.css";
import { useTranslation } from "react-i18next";
import "./Bitcoin.css";
import BitcoinInfo from "../BitcoinInfo"; // Import the component

function Bitcoin() {
	const { t } = useTranslation();
	return (
		<div className="resources-container">
			<h1 className="resource">{t("Bitcoin-temp-message")}</h1>
			<BitcoinInfo />{" "}
			{/* Add the BitcoinInfo component to display data */}
		</div>
	);
}
export default Bitcoin;
